import { isNil } from 'lodash';
import { DEFAULT_CALLOUT_PROPS } from '../../../../../Shape/config/Shapes';

const getTailAngle = shape => (isNil(shape.get('tailAngle')) ? DEFAULT_CALLOUT_PROPS.tailAngle : shape.get('tailAngle'));

export default getTailAngle;
